<template>
    <div class="echartsBox">
        <img src="@/assets/RN/bingtu.png" alt="" class="bt1">
        <img src="@/assets/RN/bt3.png" alt="" class="bt3 rotateXZ-element">
        <img src="@/assets/RN/bt2.png" alt="" class="bt2">
        <div ref="bingtu1" id="bingtu1" class="tmain2"></div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: 'template.scope19',
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            title: '环形图-scope19 ',
            timer: null,
            defaultdata: [
                { value1: "系列一", value2: 1048 },
                { value1: "系列二", value2: 735 },
                { value1: "系列三", value2: 580 },
                { value1: "系列四", value2: 484 },
                { value1: "系列五", value2: 300 },
                { value1: "系列六", value2: 300 },
                { value1: "系列七", value2: 300 },
            ],
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n
        },
        defaultdata(n) {
            this.DrawEcharts()
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.bingtu1);
            let numData = JSON.parse(JSON.stringify(this.defaultdata))
            let total = numData.reduce((sum, item) => sum + +item.value2, 0)
            if (numData.length > 7) {
                numData = numData.slice(0, 5)
            }
            var colorList = ['#2cbeff', '#08fff0', '#fed312', '#a1dcf4', '#72f3ec', '#738b99', "rgba(250,250,250,0.8)"];
            var Toption = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    right: '10%',
                    orient: "vertical",
                    formatter: (params) => {
                        let nparams = params.length > 5 ? params.slice(0, 5) + "..." : params
                        return '{a|' + nparams  + "}    " + parseInt(+(numData.filter(item => item.value1 == params)[0].value2) / total * 100 .toFixed(2)) + "%";
                    },
                    itemWidth: 10, // 设置图例图形的宽
                    itemHeight: 10, // 设置图例图形的高
                    itemGap: 15, //图例图标与文字间的间距
                    textStyle: {
                        color: "#d1e2ea", // 图例文字颜色
                        fontSize: 10,
                        rich: {
                            a: {
                                width: 70, // 每个图例的宽度，具体根据字数调整
                                verticalAlign: "center",  //设置文字与图例的对其方式
                            },
                        },
                        padding: [2, 0, 2, 4], //[上、右、下、左] 图例与文字的偏移量
                    },
                },
                grid: {
                    left: "4%",
                    right: "4%",
                    bottom: "4%",
                    top: "16%",
                    containLabel: true, // grid 区域是否包含坐标轴的刻度标签
                },
                series: [
                    // 主要展示层的
                    {
                        radius: ['45%', '62%'],
                        center: ['30%', '50%'],
                        type: 'pie',
                        avoidLabelOverlap: false,
                        padAngle: 4,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    return colorList[params.dataIndex]
                                }
                            },
                            borderRadius: 0,
                            borderColor: '#070e19', // 空隙的颜色，这里设置为白色
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            scale: false,
                            label: {
                                show: false,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: numData.map(item => {
                            return {
                                name: item.value1,
                                value: +item.value2
                            }
                        })
                    },
                    // 边框的设置
                    {
                        radius: ['55%', '62%'],
                        center: ['30%', '50%'],
                        type: 'pie',
                        avoidLabelOverlap: false,
                        padAngle: 4,

                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    return colorList[params.dataIndex]
                                }
                            },
                            borderRadius: 0,
                            borderColor: '#070e19', // 空隙的颜色，这里设置为白色
                            borderWidth: 2
                        },
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        animation: false,
                        tooltip: {
                            show: false
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgba(3,11,27,0.7)'
                            }
                        },
                        data: [{
                            value: 1,
                        }],
                    }
                ]

            };
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata
        }
        this.setData()
        this.DrawEcharts()
    },
}
</script>

<style scoped>
/* @import url('../../css/animation.css'); */
/* 旋转360 */
@keyframes rotateXZ {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.rotateXZ-element {
    animation: rotateXZ 4s linear infinite;
}

.bt3 {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 32.5%;
    left: 19.5%;
}

.bt2 {
    width: 30px;
    height: 32px;
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translate(-50%, -50%);
}

.bt1 {
    width: 192px;
    height: 191px;
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translate(-50%, -50%);
}

.echartsBox {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
    overflow: hidden;
}

.tmain2 {
    width: 100%;
    height: 100%;
}
</style>
